export var CardType;
(function (CardType) {
    CardType["Meal"] = "meal";
    CardType["WiFi"] = "wifi";
    CardType["Aircraft"] = "aircraft";
    CardType["Seats"] = "seats";
    CardType["City"] = "city";
})(CardType || (CardType = {}));
